import { useEffect, useRef } from 'react'
import { useUnit } from 'effector-react'
import {
  $disabled,
  $error,
  $status,
  $timeLeft,
  $value,
  codeChanged,
  codeCleared,
  codeSubmitted,
  newCodeRequested,
  timeLeftChanged,
} from './verificar-codigo.model'
import { stepChanged } from '../onboarding.model'
import { StepId } from '../lib/utils'

export function useVerificarCodigo() {
  const intervalRef = useRef(null)

  const emitStepChange = useUnit(stepChanged)
  const model = useUnit({
    value: $value,
    error: $error,
    status: $status,
    timeLeft: $timeLeft,
    disabled: $disabled,
    onChange: codeChanged,
    onReset: codeCleared,
    onSubmit: codeSubmitted,
    onRequestNewCode: newCodeRequested,
    onTimeLeftChange: timeLeftChanged,
  })

  useEffect(() => {
    const navigation = window.performance.getEntriesByType('navigation')[0]
    if (navigation.type === 'reload') {
      if (model.timeLeft < 0) {
        emitStepChange(StepId.VERIFY_EMAIL)
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (model.timeLeft > 0 && !intervalRef.current) {
      intervalRef.current = setInterval(() => {
        model.onTimeLeftChange()
      }, 1000)
    } else if (model.timeLeft <= 0 && intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  }, [model.timeLeft]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    onSubmit: model.onSubmit,
    onChange: model.onChange,
    onReset: model.onReset,
    onRequestNewCode: model.onRequestNewCode,
    disabled: model.disabled,
    value: model.value,
    status: model.status,
    error: model.error,
    timeLeft: model.timeLeft,
  }
}
